import { inject, observer } from 'mobx-react';
import { Company } from 'models';
import React from 'react';
import { Pages } from 'routes';
import { AuthStore, RoutingStore } from 'stores';
import { Page } from 'components';


export interface ICompanySelectProps {
  authStore?:    AuthStore,
  routingStore?: RoutingStore,
}

export const CompanySelect = inject('authStore', 'routingStore')(observer((props: ICompanySelectProps) => {
  const { authStore, routingStore } = props;
  const [companies, setCompanies] = React.useState<Company[]>([]);

  React.useEffect(() => {
    Company.get().then((c: Company[]) => setCompanies(c));
  }, []);

  // A manager must have at least one company.
  // So for error handling check: if(companies && !companies.length) {  }

  return (
    <Page 
      sidebar = {<></>}
      topbar  = {<></>}
    >
      <ul>
        {companies?.map(c => (
          <li 
            key     = {c.id}
            onClick = {() => {
              // authStore.getCurUser.setCompany(c);
              // TODO Check history if this was a re-route and route accordingly 
              routingStore.push(Pages.Library);
            }}
          >
            {c.title}
          </li>
        ))}
      </ul>
    </Page>
  );
}));